import { render, staticRenderFns } from "./ExcelTruckOrders.vue?vue&type=template&id=1b1ac4cf&scoped=true&"
import script from "./ExcelTruckOrders.vue?vue&type=script&lang=js&"
export * from "./ExcelTruckOrders.vue?vue&type=script&lang=js&"
import style0 from "./ExcelTruckOrders.vue?vue&type=style&index=0&id=1b1ac4cf&scoped=true&lang=css&"
import style1 from "./ExcelTruckOrders.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ac4cf",
  null
  
)

export default component.exports